export const GiraffeLeaderboards = () => (
  <svg viewBox="0 0 544 720" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clipLeaderboards)">
      <path d="M523.052 32.4419H221.382V220.447H523.052V32.4419Z" fill="#E3F7FC" />
      <path
        d="M533.969 30H220.019C219.159 30 218.494 30.6693 218.494 31.5354V235.465C218.494 236.291 219.159 237 220.019 237H533.969C534.79 237 535.494 236.331 535.494 235.465V31.5354C535.494 30.6693 534.829 30 533.969 30ZM520.203 220.308C520.203 221.134 519.539 221.843 518.678 221.843H235.31C234.489 221.843 233.785 221.174 233.785 220.308V46.6923C233.785 45.8655 234.45 45.1569 235.31 45.1569H518.717C519.539 45.1569 520.242 45.8262 520.242 46.6923V220.308H520.203Z"
        fill="#A0A09B"
      />
      <path
        d="M528.967 25H214.528C213.666 25 213 25.6659 213 26.5275V229.417C213 230.239 213.666 230.944 214.528 230.944H528.967C529.789 230.944 530.494 230.278 530.494 229.417V26.5275C530.494 25.6659 529.828 25 528.967 25ZM515.18 214.337C515.18 215.16 514.514 215.865 513.652 215.865H229.842C229.02 215.865 228.315 215.199 228.315 214.337V41.6071C228.315 40.7846 228.98 40.0796 229.842 40.0796H513.691C514.514 40.0796 515.219 40.7455 515.219 41.6071V214.337H515.18Z"
        fill="#D9D9D7"
      />
      <mask
        id="maskLeaderboards"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="228"
        y="40"
        width="288"
        height="176"
      >
        <path
          d="M515.359 214.258C515.359 215.08 514.693 215.785 513.832 215.785H230.022C229.199 215.785 228.494 215.119 228.494 214.258V41.5275C228.494 40.705 229.16 40 230.022 40H513.871C514.693 40 515.398 40.6659 515.398 41.5275V214.258H515.359Z"
          fill="#640038"
        />
      </mask>
      <g mask="url(#maskLeaderboards)">
        <path
          d="M340.726 134.161L294.155 26.0576H446.949L401.671 134.161H340.726Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M223.379 100.438L286.244 149.789H340.883L283.071 29.583L224.006 32.7164L223.379 100.438Z"
          fill="url(#paint1_linear)"
          fillOpacity="0.85"
        />
        <path
          d="M520.271 108.075L454.312 157.191H399.673L455.174 34.6353L519.762 37.5728L520.271 108.075Z"
          fill="url(#paint2_linear)"
          fillOpacity="0.85"
        />
        <path d="M436.491 207.522H392.858V157.191H454.312L436.491 207.522Z" fill="#5FEEBF" />
        <path d="M304.065 207.522H347.698V149.789H286.244L304.065 207.522Z" fill="#50D4F8" />
        <path
          d="M394.738 207.287H346.405L339.394 134.161H401.749L394.738 207.287Z"
          fill="#BCA2FC"
        />
        <path
          d="M366.538 150.963C366.263 151.159 365.989 151.238 365.676 151.238C364.893 151.238 364.188 150.532 364.188 149.749C364.188 149.279 364.423 148.77 364.853 148.496L372.099 143.482C372.413 143.247 372.687 143.169 373.039 143.169C373.862 143.169 374.567 143.874 374.567 144.696V173.367C374.567 174.19 373.862 174.895 373.039 174.895C372.217 174.895 371.512 174.19 371.512 173.367V147.399L366.538 150.963Z"
          fill="white"
        />
        <path
          d="M315.698 155.233C320.789 155.389 324.667 158.249 325.96 162.322C328.545 170.587 315.619 172.702 316.951 176.736L329.759 176.971C330.386 176.971 331.051 177.441 331.208 178.028C331.404 178.577 331.012 179.047 330.425 179.047L316.324 178.812C315.698 178.812 315.032 178.342 314.836 177.754C312.29 170.312 325.881 169.764 323.492 162.283C322.63 159.58 320.006 157.465 316.442 157.387C313.269 157.309 312.407 158.758 312.133 160.52C312.055 160.99 311.781 161.225 311.272 161.186C310.645 161.186 309.94 160.677 309.705 160.05C309.705 160.011 309.627 159.855 309.666 159.659C309.705 156.8 311.781 155.115 315.698 155.233Z"
          fill="white"
        />
        <path
          d="M421.098 173.524C427.169 173.367 428.266 176.775 427.561 180.379C426.777 184.374 423.644 186.724 418.396 187.037C414.635 187.233 412.325 185.94 411.11 184.021C411.032 183.864 410.954 183.708 410.993 183.512C411.032 182.964 411.58 182.533 412.207 182.533C412.52 182.533 412.912 182.611 413.147 183.003C414.087 184.53 415.81 185.431 418.67 185.314C422.547 185.118 424.702 183.434 425.25 180.535C425.798 177.598 424.819 175.522 420.628 175.639L418.004 175.718C417.377 175.757 416.907 175.326 416.986 174.738C417.025 174.425 417.181 174.229 417.377 173.994L425.602 166.082L415.38 166.2C414.675 166.2 414.205 165.73 414.283 165.064C414.361 164.398 414.949 163.889 415.654 163.889L428.658 163.811C429.323 163.811 429.715 164.281 429.598 164.946C429.558 165.221 429.402 165.495 429.128 165.73L420.706 173.602L421.098 173.524Z"
          fill="white"
        />
        <path
          d="M320.907 219.781C330.151 219.781 337.632 211.83 337.632 202.038C337.632 192.246 330.151 184.295 320.907 184.295C311.664 184.295 304.183 192.246 304.183 202.038C304.183 211.83 311.664 219.781 320.907 219.781Z"
          fill="white"
        />
        <path
          d="M261.842 222.406C271.085 222.406 278.566 214.455 278.566 204.663C278.566 194.871 271.085 186.92 261.842 186.92C252.598 186.92 245.117 194.871 245.117 204.663C245.117 214.455 252.598 222.406 261.842 222.406Z"
          fill="white"
        />
        <path
          d="M279.585 221.7C288.829 221.7 296.31 213.749 296.31 203.957C296.31 194.165 288.829 186.214 279.585 186.214C270.342 186.214 262.861 194.165 262.861 203.957C262.821 213.749 270.342 221.7 279.585 221.7Z"
          fill="white"
        />
        <path
          d="M299.795 217.784C309.039 217.784 316.52 209.833 316.52 200.041C316.52 190.249 309.039 182.298 299.795 182.298C290.552 182.298 283.071 190.249 283.071 200.041C283.071 209.833 290.552 217.784 299.795 217.784Z"
          fill="white"
        />
        <path
          d="M399.673 232.315C408.917 232.315 416.398 224.364 416.398 214.572C416.398 204.78 408.917 196.829 399.673 196.829C390.43 196.829 382.949 204.78 382.949 214.572C382.949 224.364 390.43 232.315 399.673 232.315Z"
          fill="white"
        />
        <path
          d="M385.886 235.448C395.13 235.448 402.611 227.497 402.611 217.705C402.611 207.913 395.13 199.962 385.886 199.962C376.643 199.962 369.162 207.913 369.162 217.705C369.162 227.497 376.643 235.448 385.886 235.448Z"
          fill="white"
        />
        <path
          d="M423.331 228.085C432.574 228.085 440.055 220.134 440.055 210.342C440.055 200.55 432.574 192.599 423.331 192.599C414.087 192.599 406.606 200.55 406.606 210.342C406.567 220.134 414.087 228.085 423.331 228.085Z"
          fill="white"
        />
        <path
          d="M328.819 233.373C338.063 233.373 345.544 225.422 345.544 215.63C345.544 205.838 338.063 197.887 328.819 197.887C319.575 197.887 312.094 205.838 312.094 215.63C312.055 225.422 319.575 233.373 328.819 233.373Z"
          fill="white"
        />
        <path
          d="M350.439 233.373C359.683 233.373 367.164 225.422 367.164 215.63C367.164 205.838 359.683 197.887 350.439 197.887C341.196 197.887 333.715 205.838 333.715 215.63C333.715 225.422 341.235 233.373 350.439 233.373Z"
          fill="white"
        />
        <path
          d="M363.757 222.915C368.927 222.915 373.118 218.489 373.118 213.006C373.118 207.522 368.927 203.096 363.757 203.096C358.586 203.096 354.396 207.522 354.396 213.006C354.396 218.489 358.586 222.915 363.757 222.915Z"
          fill="white"
        />
        <path
          d="M438.45 220.408C447.693 220.408 455.174 212.457 455.174 202.665C455.174 192.873 447.693 184.922 438.45 184.922C429.206 184.922 421.725 192.873 421.725 202.665C421.725 212.457 429.206 220.408 438.45 220.408Z"
          fill="white"
        />
        <path
          d="M450.474 211.987C459.718 211.987 467.199 204.036 467.199 194.244C467.199 184.452 459.718 176.501 450.474 176.501C441.231 176.501 433.75 184.452 433.75 194.244C433.75 204.036 441.231 211.987 450.474 211.987Z"
          fill="white"
        />
        <path
          d="M475.816 209.833C485.06 209.833 492.541 201.882 492.541 192.09C492.541 182.298 485.06 174.347 475.816 174.347C466.572 174.347 459.091 182.298 459.091 192.09C459.091 201.882 466.572 209.833 475.816 209.833Z"
          fill="white"
        />
        <path
          d="M503.546 220.839C512.79 220.839 520.271 212.888 520.271 203.096C520.271 193.304 512.79 185.353 503.546 185.353C494.303 185.353 486.822 193.304 486.822 203.096C486.822 212.888 494.303 220.839 503.546 220.839Z"
          fill="white"
        />
        <path d="M285.852 196.242H235.913V230.357H285.852V196.242Z" fill="white" />
        <path d="M502.41 193.813H432.183V230.004H502.41V193.813Z" fill="white" />
      </g>
      <path
        d="M378.747 227.223H376.201C374.987 227.223 373.969 226.244 373.969 224.991V222.445C373.969 221.231 374.948 220.212 376.201 220.212H378.747C379.961 220.212 380.98 221.192 380.98 222.445V224.991C380.98 226.244 380.001 227.223 378.747 227.223Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4944 560.392V511.754C19.4944 495.217 33.0383 481.673 49.5753 481.673H74.0442C103.227 481.673 141.838 447.776 147.525 425.178C153.212 402.58 198.334 202.863 198.334 202.863L240.761 221.346L186.735 487.21C186.735 565.106 182.47 696.654 182.47 696.654C182.47 709.375 177.157 714.538 164.362 714.538C164.362 714.538 152.763 717.232 151.641 707.803L140.566 583.738C140.117 576.63 135.852 573.263 130.09 573.263H108.465C102.703 573.263 97.9892 577.977 97.9892 583.738L92.4519 698.824C92.4519 711.545 87.5881 720.15 74.8673 720.15C62.1465 720.15 61.6975 721.647 61.6975 708.851L52.4188 581.419C52.0447 576.031 51.8202 570.569 51.8202 565.181V511.454C51.8202 505.468 53.6909 499.781 56.9833 494.992H49.5753C40.5211 494.992 33.1132 502.325 33.1132 511.454V560.168L19.4944 560.392Z"
        fill="#FFDD08"
      />
      <path
        d="M207.687 136.566C208.061 134.845 209.184 133.423 210.755 132.6L212.701 131.627C214.272 130.804 216.143 130.804 217.714 131.552C219.285 132.3 220.483 133.722 220.857 135.443L221.455 138.212C221.53 138.586 221.68 138.96 221.904 139.185L222.503 139.933C223.401 141.055 224.149 142.253 224.748 143.525L228.564 152.654L234.999 145.395L235.074 145.246C236.122 144.273 237.169 143.375 238.367 142.552L239.19 142.028C239.489 141.804 239.788 141.579 240.013 141.13L241.435 138.811C242.333 137.314 243.904 136.341 245.7 136.117C247.496 135.892 249.217 136.566 250.414 137.838L251.911 139.409C253.183 140.681 253.781 142.402 253.557 144.123C253.332 145.844 252.359 147.416 250.863 148.314L248.468 149.735C248.169 149.885 247.87 150.184 247.645 150.484L247.122 151.307C246.298 152.504 245.4 153.552 244.428 154.599L237.319 160.361C234.55 162.606 232.755 165.898 231.931 170.463C231.707 171.81 231.183 174.653 231.183 174.653L229.761 183.109L217.49 181.163L219.136 172.708C219.136 172.708 219.585 169.864 219.809 168.517C220.408 163.953 219.809 160.211 217.939 157.218L213.15 149.661L213.075 149.436C212.476 148.164 211.952 146.817 211.578 145.47L211.354 144.497C211.279 144.123 211.054 143.824 210.755 143.45L208.959 141.355C207.762 140.083 207.388 138.287 207.687 136.566Z"
        fill="#7A4412"
      />
      <path
        d="M178.505 157.218C184.715 157.517 191.151 159.014 195.79 163.204C199.681 166.646 203.048 170.687 204.919 175.551C207.164 181.312 209.034 187.224 210.98 196.652C210.98 196.652 204.171 200.019 204.769 201.815C196.763 201.74 184.192 202.115 177.906 197.849C171.246 193.36 168.178 188.271 165.484 180.639C162.791 173.006 162.641 164.775 160.695 156.993C166.607 156.993 173.192 156.993 178.505 157.218Z"
        fill="#FFDD08"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M214.347 172.708C210.231 171.81 205.891 172.408 202.3 174.578C202 174.803 201.701 174.953 201.477 175.177C197.735 178.17 195.116 181.612 195.116 186.925V252.923H239.863H254.829C254.904 252.923 255.503 252.923 255.577 252.923C271.366 252.923 285.509 242.672 290.372 227.632C290.447 227.482 290.447 227.407 290.447 227.257C290.447 227.183 290.522 227.108 290.522 227.033C294.787 211.095 280.794 197.626 266.502 190.367C259.618 186.85 241.36 180.34 228.939 176C228.265 175.776 227.592 175.551 226.918 175.402L214.347 172.708Z"
        fill="#FFDD08"
      />
      <path
        d="M236.721 200.993C235 200.095 232.979 199.796 231.258 200.544C229.687 201.218 228.489 202.415 227.816 203.837C227.143 205.333 224.898 205.183 224.598 203.537V203.462C224 200.245 225.422 196.878 228.115 195.007C232.68 191.864 238.666 193.81 240.761 198.599C241.061 199.272 241.21 199.946 241.36 200.619C241.584 202.19 239.714 203.238 238.516 202.19C237.918 201.741 237.394 201.367 236.721 200.993Z"
        fill="#3E3E3D"
      />
      <path
        d="M33.0907 559.473C33.0907 559.473 45.2593 576.378 40.8232 580.091C36.3871 583.804 31.1014 574.188 31.1014 574.188C31.1014 574.188 37.0478 592.088 30.252 593.611C23.4562 595.135 22.1348 576.187 22.1348 576.187C22.1348 576.187 17.5098 587.518 12.6018 583.804C7.6937 580.091 19.6603 559.473 19.6603 559.473H33.0907Z"
        fill="#C78800"
      />
      <path
        d="M234.326 252.924C234.326 252.924 217.415 252.624 208.66 247.012C208.66 247.012 216.442 260.332 232.081 263.998C232.081 263.923 234.326 252.924 234.326 252.924Z"
        fill="#E1C31E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M152.464 700.77L179.552 695.382C181.497 695.008 183.368 696.131 183.967 698.001L189.429 715.137C190.252 717.606 188.382 720.15 185.763 720.15H151.866C149.546 720.15 147.75 718.13 148.049 715.885L149.396 704.062C149.621 702.416 150.818 701.069 152.464 700.77Z"
        fill="#C98D2B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.7454 700.77L89.8332 695.382C91.7788 695.008 93.6495 696.131 94.2481 698.001L99.7105 715.137C100.534 717.606 98.6629 720.15 96.044 720.15H62.1468C59.8271 720.15 58.0313 718.13 58.3306 715.885L59.6775 704.062C59.902 702.416 61.0992 701.069 62.7454 700.77Z"
        fill="#C98D2B"
      />
      <mask
        id="maskLeaderboards1"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="19"
        y="202"
        width="223"
        height="519"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.7781 560.446V511.808C19.7781 495.271 33.322 481.727 49.859 481.727H74.3279C103.511 481.727 142.122 447.83 147.809 425.232C153.496 402.634 198.617 202.917 198.617 202.917L241.045 221.4L187.019 487.264C187.019 565.16 182.754 696.708 182.754 696.708C182.754 709.429 177.441 714.592 164.645 714.592C164.645 714.592 153.047 717.286 151.925 707.858L140.85 583.793C140.401 576.684 136.136 573.317 130.374 573.317H108.749C102.987 573.317 98.2728 578.031 98.2728 583.793L92.7356 698.878C92.7356 711.599 87.8717 720.204 75.151 720.204C62.4302 720.204 61.9812 721.701 61.9812 708.905L52.7025 581.473C52.3284 576.085 52.1039 570.623 52.1039 565.235V511.509C52.1039 505.522 53.9746 499.835 57.267 495.046H49.859C40.8048 495.046 33.3969 502.38 33.3969 511.509V560.222L19.7781 560.446Z"
          fill="#FFD600"
        />
      </mask>
      <g mask="url(#maskLeaderboards1)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.144 342.493C180.674 342.493 178.654 344.513 178.654 346.982C178.654 349.452 180.674 351.472 183.144 351.472C185.613 351.472 187.633 349.452 187.633 346.982C187.633 344.513 185.613 342.493 183.144 342.493Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M152.913 411.185C150.444 411.185 148.423 413.205 148.423 415.674C148.423 418.144 150.444 420.164 152.913 420.164C155.382 420.164 157.403 418.144 157.403 415.674C157.403 413.205 155.457 411.185 152.913 411.185Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M171.022 374.668C167.729 374.668 165.035 377.362 165.035 380.655C165.035 383.947 167.729 386.566 171.022 386.566C174.314 386.566 176.933 383.872 176.933 380.655C177.008 377.287 174.314 374.668 171.022 374.668Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M189.055 401.382C185.763 401.382 183.069 404.076 183.069 407.369C183.069 410.661 185.763 413.28 189.055 413.28C192.348 413.28 194.967 410.586 194.967 407.369C195.042 404.076 192.348 401.382 189.055 401.382Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M177.606 307.473C173.94 307.473 170.947 310.466 170.947 314.133C170.947 317.799 173.94 320.793 177.606 320.793C181.273 320.793 184.266 317.799 184.266 314.133C184.266 310.466 181.273 307.473 177.606 307.473Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M205.517 365.764C200.653 365.764 196.687 369.73 196.687 374.593C196.687 379.457 200.653 383.423 205.517 383.423C210.381 383.423 214.272 379.457 214.272 374.593C214.272 369.73 210.381 365.764 205.517 365.764Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M217.265 326.33C213.374 326.33 210.156 329.547 210.156 333.438C210.156 337.329 213.374 340.547 217.265 340.547C221.156 340.547 224.374 337.329 224.374 333.438C224.374 329.547 221.231 326.33 217.265 326.33Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M153.886 468.877C157.628 465.136 163.838 465.285 167.43 469.326C170.722 473.068 170.273 478.755 166.757 482.271L155.682 493.346C154.634 494.394 152.988 494.394 152.015 493.346L140.941 482.271C137.424 478.755 137.05 473.068 140.342 469.326C143.934 465.211 150.145 465.061 153.886 468.877Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M125.152 484.741C122.383 484.741 120.138 486.986 120.138 489.754C120.138 492.523 122.383 494.768 125.152 494.768C127.92 494.768 130.165 492.523 130.165 489.754C130.165 486.986 127.92 484.741 125.152 484.741Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M77.2619 485.265C74.4933 485.265 72.2484 487.51 72.2484 490.278C72.2484 493.047 74.4933 495.292 77.2619 495.292C80.0305 495.292 82.2754 493.047 82.2754 490.278C82.2006 487.51 80.0305 485.265 77.2619 485.265Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M99.7852 494.394C94.9213 494.394 90.9554 498.359 90.9554 503.223C90.9554 508.087 94.9213 512.053 99.7852 512.053C104.649 512.053 108.54 508.087 108.54 503.223C108.54 498.359 104.649 494.394 99.7852 494.394Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M105.547 462.966C100.683 462.966 96.7171 466.932 96.7171 471.796C96.7171 476.659 100.683 480.625 105.547 480.625C110.411 480.625 114.302 476.659 114.302 471.796C114.302 466.932 110.411 462.966 105.547 462.966Z"
          fill="#C98D2B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M130.315 451.068C127.022 451.068 124.328 453.762 124.328 457.055C124.328 460.347 127.022 462.966 130.315 462.966C133.607 462.966 136.226 460.272 136.226 457.055C136.226 453.687 133.607 451.068 130.315 451.068Z"
          fill="#C98D2B"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M259.743 288.437C257.266 289.35 254.528 288.177 253.616 285.699L251.986 281.461C251.074 278.984 252.247 276.245 254.724 275.333C257.201 274.42 259.938 275.593 260.851 278.071L262.48 282.309C263.393 284.721 262.22 287.46 259.743 288.437Z"
        fill="#5C5757"
      />
      <path
        d="M259.091 285.634C259.091 285.634 272.714 309.887 270.042 347.963"
        stroke="#5C5757"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path d="M244 370H182V720H244V370Z" fill="#D37AB5" />
      <path d="M289 370H244V720H289V370Z" fill="#F7B7D6" />
      <path d="M250.552 348H174.748V370.167H250.552V348Z" fill="#D37AB5" />
      <path d="M294.289 348H250.553V370.167H294.289V348Z" fill="#F7B7D6" />
      <path d="M288.683 370H181.853" stroke="#AF588E" strokeMiterlimit="10" />
    </g>
    <defs>
      <linearGradient
        id="leaderboards-paint0_linear"
        x1="370.507"
        y1="62.1621"
        x2="370.368"
        y2="136.007"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="leaderboards-paint1_linear"
        x1="262.335"
        y1="74.7374"
        x2="297.847"
        y2="165.124"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="leaderboards-paint2_linear"
        x1="485.871"
        y1="74.8027"
        x2="443.157"
        y2="170.216"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00320703" stopColor="white" stopOpacity="0" />
        <stop offset="0.1189" stopColor="white" stopOpacity="0.1161" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <clipPath id="clipLeaderboards">
        <rect width="544" height="720" rx="8" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
